<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg width="100%" height="100%" viewBox="0 0 955 955" version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
  <g>
    <g>
      <path d="M383.439,627.578c0,-12.321 -9.737,-20.618 -21.765,-18.497l-143.765,25.346c-12.028,2.12 -21.765,13.851 -21.765,26.171l-0,271.864c-0,12.348 9.737,20.645 21.765,18.525l143.765,-25.346c12.028,-2.121 21.765,-13.851 21.765,-26.2l0,-271.863Z" style="fill:#fff;"/>
    </g>
    <g>
      <path d="M758.023,18.828c-0,-12.321 -9.737,-20.618 -21.765,-18.497l-143.766,25.346c-12.028,2.12 -21.765,13.851 -21.765,26.171l0,271.864c0,12.348 9.737,20.645 21.765,18.525l143.766,-25.346c12.028,-2.121 21.765,-13.851 21.765,-26.2l-0,-271.863Z" style="fill:#fff;"/>
    </g>
    <g>
      <path d="M406.641,82.425c-5.553,-12.23 -20.479,-20.287 -33.366,-18.015l-154.034,27.156c-12.887,2.272 -18.826,14.008 -13.274,26.238l341.087,751.231c5.553,12.23 20.511,20.358 33.398,18.086l154.034,-27.156c12.888,-2.273 18.795,-14.079 13.242,-26.309l-341.087,-751.231Z" style="fill:#fff;"/>
    </g>
  </g>
</svg>
